import React, {useEffect, useState} from 'react';
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import {getFireStatusEvents} from "../../api/apiClient";
import Moment from "moment";
import TableFireStatusEvents from "../../components/tables/TableFireStatusEvents";


const FireEventDetail = ({
                           propFireNo = 0,
                           propStartDate,
                           propEndDate,
                         }) => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const updateList = (page = 1) => {
    getFireStatusEvents(
        currentPage,
        listPageSize,
        propFireNo,
        Moment(propStartDate).format('YYYY-MM-DD'),
        Moment(propEndDate).format('YYYY-MM-DD'))
        .then(res => {
          if (res.data.data !== undefined) {
            setTotal(res.data.data.total);
            setTableList(res.data.data.list);
          }
        });
  };


  useEffect(() => {
    updateList();
  }, []);

  useEffect(() => {
    updateList();
  }, [currentPage, listPageSize]);

  return (
      <Container fluid className={""}>
        <Row className={"p-3"}>
          <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
            <TableFireStatusEvents
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                listPageSize={listPageSize}
                setListPageSize={setListPageSize}
                total={total}
                tableList={tableList}
                updateList={updateList}
                setTableList={setTableList}
                setTotal={setTotal}
                propFireNo={propFireNo}
                propStartDate={propStartDate}
                propEndDate={propEndDate}
            />
          </Col>
        </Row>
      </Container>
  );
};


export default FireEventDetail;
